// extracted by mini-css-extract-plugin
export default {"inputWrapper":"input_inputWrapper__EU-CH","disabled":"input_disabled__Ob-X1","input":"input_input__EBh3D","normal":"input_normal__uEM-j","small":"input_small__fOeCN"};